import React from 'react'

const Adverties = () => {
  return (
    <div>Adverties Page</div>
  )
}

export default Adverties;